import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'

export class TextButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    children: null,
    onClick: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-text-button', className)
  }

  render() {
    const { className } = this
    const { children, onClick } = this.props
    return (
      <div className={className} onClick={onClick}>
        {children}
      </div>
    )
  }
}

export default TextButton
